import axios from "axios";

// buat base url untuk deploy dengan netify
export const API = axios.create({
  baseURL: process.env.REACT_APP_API_KEY,
});


// buat base url untuk local
// export const API = axios.create({
//   baseURL: "https://api-gw.signatureanugerah.co.id/",
// });

// Set Authorization Token Header
export const setAuthToken = (token) => {
  if (token) {
    API.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete API.defaults.headers.commin["Authorization"];
  }
};
